// extracted by mini-css-extract-plugin
export default {"container":"ScopeTag_container__XQPbt","icon":"ScopeTag_icon__VhEat","title":"ScopeTag_title__FttR7"};